"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useComputed_1 = __importDefault(require("./useComputed"));

var binding = function binding(state, key) {
  return useComputed_1.default({
    get value() {
      return state[key];
    },

    set value(value) {
      state[key] = value;
    }

  }, [state[key]]);
};

var handlers = {
  get: binding
};

function useBinding(state) {
  return react_1.useMemo(function () {
    return new Proxy(state, handlers);
  }, [state]);
}

exports.default = useBinding;